<template>
    <div class="uk-card uk-card-default uk-card-small simple-card">
        <div class="uk-card-header uk-flex uk-flex-between">
            <h4>
                <i class="material-icons">settings</i>
                설정
            </h4>


            <button
                type="button"
                class="uk-button uk-button-small uk-button-black"
                @click="removeConfig">
                <i class="material-icons">refresh</i>
                설정 초기화
            </button>
        </div>

        <!-- 미적용지역 안내문 (라벨로 판단) -->
        <div class="uk-card-body" v-if="! printer.label">
            <div class="text-red uk-text-center">
                라벨출력 신규방식 미적용 지역
            </div>

        </div>

        <!-- 적용지역 (라벨로 판단) -->
        <div class="uk-card-body" v-if="printer.label">
            <table class="info-table uk-width-1-1">
                <colgroup>
                    <col style="width: 10rem">
                    <col style="">
                </colgroup>
                <tr>
                    <th>
                        센터
                    </th>
                    <td>
                        <img :src="region.flag32"/>
                        {{ region.name }}
                    </td>
                </tr>
                <tr>
                    <th>
                        QZ Tray 버전
                    </th>
                    <td>
                        <!-- qz 버전 -->
                        {{ qzManager.version }}


                        <!-- 접속안내 -->
                        <span v-if="connected.status === 'connecting'" class="ml-1 text-gray font-size-0d875rem">
                            <loading-icon></loading-icon>
                            {{ connected.msg }}
                        </span>
                        <span v-if="connected.status === 'success'"
                              class="ml-1 text-green font-bold font-size-0d875rem">
                            {{ connected.msg }}
                        </span>
                        <span v-if="connected.status === 'fail'" class="ml-1 text-red font-size-0d875rem">
                            {{ connected.msg }}
                        </span>


                        <!-- 최신버전 설치안내 -->
                        <div v-if="qzManager.under_2_1" class="mt-1rem">
                            <div class="text-white bg-red p-0d5rem mb-1rem" v-if="qzManager.connected">QZ Tray 최신버전을
                                설치하세요.
                            </div>
                            <a class="uk-button uk-button-small uk-button-default" href="/down/qz-tray-2.2.4-x86_64.exe"
                               download="">QZ Tray 2.2.4 다운로드</a>
                            <ul class="m-0">
                                <li class="p-0">설치 후, Automatically Start 체크</li>
                                <li class="p-0">PC 재부팅</li>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>
                        프린터
                    </th>
                    <td>
                        <div class="uk-flex uk-flex-between uk-flex-middle">
                            <div v-if="printer.getPrinterName()">
                                {{ printer.getPrinterName() }}

                                <button
                                    type="button"
                                    class="uk-button uk-button-small uk-button-gray"
                                    @click="findPrinter"
                                >
                                    <i class="material-icons">sensors</i>
                                    프린터명 확인
                                </button>

                                <!-- 연결테스트 안내 -->
                                <div v-if="printerConnected.status === 'success'"
                                     class="ml-1 text-green font-size-0d875rem">
                                    {{ printerConnected.msg }}
                                </div>
                                <div v-if="printerConnected.status === 'fail'" class="ml-1 text-red font-size-0d875rem">
                                    {{ printerConnected.msg }}
                                </div>

                            </div>
                            <div v-if="! printer.getPrinterName()" class="text-gray">
                                선택된 프린터가 없습니다.
                            </div>

                            <button
                                type="button"
                                class="uk-button uk-button-small uk-button-black"
                                @click="printerApi().findPrinters(regionId)">
                                <i class="material-icons">search</i>
                                프린터 찾기
                            </button>
                        </div>

                    </td>
                </tr>
                <tr>
                    <th>
                        라벨용지
                    </th>
                    <td>
                        <div class="uk-flex uk-flex-between uk-flex-middle">
                            <div>
                                {{ printer.label }}
                            </div>

                            <button
                                type="button"
                                class="uk-button uk-button-small uk-button-black"
                                @click="printerApi().changeLabel(regionId)">
                                <i class="material-icons">edit</i>
                                라벨용지 변경
                            </button>
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>
                        출력방식
                    </th>
                    <td>
                        <div class="uk-flex uk-flex-between uk-flex-middle">
                            <div>
                                {{ printer.printType }}
                            </div>

                            <button
                                type="button"
                                class="uk-button uk-button-small uk-button-black"
                                @click="printerApi().changePrintType(regionId)">
                                <i class="material-icons">edit</i>
                                출력방식 변경
                            </button>
                        </div>
                    </td>
                </tr>
            </table>

            <div class="uk-text-center mt-1rem">


                <button type="button" class="uk-button uk-button-gray" @click="printerApi().printSamplePdf(regionId)">
                    <i class="material-icons">print</i>
                    테스트인쇄(PDF)
                </button>

            </div>
        </div>

        <!-- 개발모드 -->
        <div class="uk-flex uk-flex-center border-t-2 p-1rem" v-if="devMode">
            <app-input-text v-model="houseId" class="w-10rem" placeholder="house id"></app-input-text>
            <app-input-text v-model="blno" class="w-10rem" placeholder="blno"></app-input-text>
            <button type="button" class="uk-button uk-button-white mr-2rem" @click="printerApi().printBl(regionId, houseId, blno)">
                <i class="material-icons">print</i>
                실제송장 인쇄
            </button>
        </div>
        <div class="uk-flex uk-flex-center border-t-2 p-1rem" v-if="devMode">
            <app-input-text v-model="prodId" class="w-10rem" placeholder="prod id"></app-input-text>
            <button type="button" class="uk-button uk-button-white mr-2rem" @click="printerApi().printStoreLabel(regionId, prodId)">
                <i class="material-icons">print</i>
                보관라벨 인쇄
            </button>
        </div>
        <div class="uk-flex uk-flex-center border-t-2 p-1rem" v-if="devMode">
            <app-input-text v-model="houseId" class="w-10rem" placeholder="house id"></app-input-text>
            <button type="button" class="uk-button uk-button-white mr-2rem" @click="printerApi().printShipoutHoldLabel(regionId, houseId)">
                <i class="material-icons">print</i>
                출고보류라벨 인쇄
            </button>
        </div>
    </div>
</template>

<script>
import regionAble from "../common/region-able.vue";
import LoadingIcon from "../common/loading-icon.vue";

// 프린터 관리객체
import {qzManager, get_printer} from "../../../classes/printer-manager";


export default {
    components: {LoadingIcon},
    mixins: [
        regionAble,
    ],
    props: {
        /**
         * 지역ID
         */
        regionId: {
            type: Number,
            default: null,
        },
        /**
         * 개발모드
         */
        devMode: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            // (Object) 지역정보 객체
            region: this.get_region(this.regionId),

            // (Object) 프린터정보
            printer: get_printer(this.regionId),

            // (Object) qz 정보
            qzManager: qzManager,

            // (object) qz 커넥트 테스트 결과
            connected: {
                status: null, // success, fail, connecting, null
                msg: null, // 결과메세지
            },

            // (object) 프린트연결 테스트 결과
            printerConnected: {
                status: null, // success, fail, null
                msg: null, // 결과메세지
            },

            // 테스트 출력용 하우스ID
            houseId: '1038482',
            prodId: '1273421',
            blno: '',
        };
    },
    computed: {
    },
    mounted() {
        this.connectQz();
    },
    methods: {
        /**
         * qz 연결
         */
        connectQz() {
            if (this.connected.status === 'connecting') {
                return;
            }
            this.connected.status = 'connecting';
            this.connected.msg = 'QZ Tray 연결중....';

            this.qzManager.connect().then(() => {
                this.connected.status = 'success';
                this.connected.msg = 'OK';

            }).catch((errmsg) => {
                this.connected.status = 'fail';
                this.connected.msg = errmsg;

            });
        },

        /**
         * 프린터 연결
         */
        findPrinter() {
            this.printerConnected.status = null;

            this.printer.findPrinter().then(() => {
                this.printerConnected.status = 'success';
                this.printerConnected.msg = '프린터를 정상적으로 조회하였습니다.';
            }).catch((errmsg) => {
                this.printerConnected.status = 'fail';
                this.printerConnected.msg = errmsg;
            });
        },


        /**
         * pdf 방식 테스트프린트
         */
        printPdfTest() {
            this.printer.printPdf().catch((err) => {
                alert(err);
            });
        },

        /**
         * 설정 초기화
         */
        removeConfig() {
            this.printer.removeConfig();
            location.reload();
        },

    },// end methods
}
</script>

<style lang="scss" scoped>
</style>